import { BookOpen } from "lucide-react";
import { scrollToSection } from "@/lib/scroll";
import NewsletterSignup from "@/components/NewsletterSignup";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[rgba(212,175,55,0.2)] bg-[#100c08] px-6 py-12 md:px-12"
    >
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col gap-8 border-b border-[rgba(212,175,55,0.15)] pb-10 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="font-cinzel text-[11px] tracking-[0.35em] text-abbey-gold">
              NEW RELEASE ALERTS
            </p>
            <p className="mt-3 max-w-sm font-cormorant text-xl italic leading-snug text-abbey-cream/70">
              Be the first to know when the next book arrives.
            </p>
          </div>
          <NewsletterSignup idPrefix="footer" compact />
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-8 md:flex-row">
          <button
            data-testid="footer-logo"
            onClick={() => window.__lenis?.scrollTo(0, { duration: 1.4 })}
            className="flex items-center gap-3"
          >
            <BookOpen className="h-4 w-4 text-abbey-gold" strokeWidth={1.5} />
            <span className="font-cinzel text-xs font-semibold tracking-[0.25em] text-abbey-gold">
              FRJOHNBOOK.SHOP
            </span>
          </button>

          <p className="text-center font-cormorant text-base italic text-abbey-cream/50">
            All books exclusively on Amazon KDP — most also on Audible.
          </p>

          <p className="font-cinzel text-[10px] tracking-[0.25em] text-abbey-cream/40">
            © {new Date().getFullYear()} FR. J. STOPA
          </p>
        </div>
      </div>
    </footer>
  );
}
